module.exports = __webpack_public_path__ + "static/47-54eabf9981809267e74ae0973d22d6a3.png";